import React, {useMemo} from 'react';
import {Link, useNavigate, useParams} from "react-router-dom";
import TalentTeamPanel from "./components/TalentTeamPanel";
// import { useQuery } from "react-query";
import {useIsMutating} from '@tanstack/react-query';
import CardList from '../../components/CardList';
import StatusTabs from '../../components/nav/StatusTabs';
import TalentTeamWelcome from './TalentTeamWelcome';
import LoadingBanner from '../../components/LoadingBanner';
import TalentTeamProvider from '../../providers/TalentTeamProvider';
import {Empty} from "antd";
import ErrorBanner from "../../components/ErrorBanner";
import {useAuth} from "../../providers/AuthProvider";
import {useAPI} from "../../config/API";
import PageNotAllowed from "../../components/errors/PageNotAllowed";

const tabNames = ['All', 'Invited', 'Pending Setup', 'Approved/Inactive', 'Approved/Active'];

const TalentTeamsList = (props) => {
    const {auth} = useAuth();
    const {status} = useParams();
    const navigate = useNavigate();

    const {
        data: teams,
        isFetching,
        error,
        refetch
    } = useAPI(['fetchAllTeamsForTalent', {status}]);

    const isTalentTeamMutating = useIsMutating('talentTeamRequest')

    const tabs = useMemo(() => {

        let filteredTabs = TB.reduce(tabNames, (result, tab) => {
            result[tab] = TB.map(TB.filter(teams || [], team => team.statusDisplay() === tab), 'id');
            return result
        }, {})
        filteredTabs['All'] = TB.map(teams || [], 'id')

        return filteredTabs;
    }, [teams, isFetching]);

    const activeTab = useMemo(() => TB.find(tabNames, tabName => status === TB.slugify(tabName)), [status]);

    const filteredTeams = useMemo(() => {
        if (status === 'all') return teams;
        return TB.filter(teams || [], team => TB.slugify(team.statusDisplay()) === status);
    }, [status, isFetching, teams]);
    if (auth.isTalent() && !auth.isProfileApproved()) {
        return <PageNotAllowed redirect="/talent/dashboard" message="Your profile must be approved before accessing this page."/>;
    }
    if (!isFetching && !error && !teams?.length) {
        return (
            <TalentTeamWelcome actionButtonText="Get Started" onClick={() => {
                return navigate('/talent/team/setup/new')
            }}/>
        )
    }
    const teamType = auth?.canManageClientResourceTalent?.() ? 'supplier' : 'talent';

    return (
        <div className="talent-teams-list flex flex-col gap-4 items-stretch">

            <div className="py-6 bg-gray project-status-tabs flex flex-col-reverse gap-y-4 lg:flex-row">

                <div className="hidden lg:block flex-1"/>

                <div className="pl7 lg:pl-0 flex flex-wrap gap-4 justify-center">
                    <StatusTabs
                        tabs={tabs}
                        isDisabled={isFetching}
                        buttonStyles={{width: 'unset'}}
                        activeTab={activeTab}
                        onChange={(tab) => {
                            return navigate({
                                pathname: `../${TB.slugify(tab)}`
                            }, {replace: true})
                        }}/>
                </div>

                <div className="flex-1 flex justify-end pr-7">
                    <Link to={`/${teamType}/team/setup`} className="btn btn-primary">
                        Add New Team
                    </Link>
                </div>

            </div>

            {isFetching && (
                <LoadingBanner/>
            )}
            {!isFetching && error && (
                <div className="self-center my-4 mx-auto p-5 flex flex-col min-w-[300px] items-center justify-center bg-white">
                    <ErrorBanner title="Something went wrong" message="Failed to load teams" onRetry={() => refetch()}/>
                </div>
            )}
            {!isFetching && !error && (filteredTeams?.length > 0 ? (
                <div className="p-3">
                    <CardList
                        fillContainer={true}
                        items={filteredTeams.map(team => (
                        <TalentTeamProvider model={team} key={`team-${team.id}`}>
                            <TalentTeamPanel isDisabled={isTalentTeamMutating > 0}/>
                        </TalentTeamProvider>
                    ))}/>
                </div>
            ) : (
                <div className="self-center my-4 mx-auto p-5 flex flex-col min-w-[300px] items-center justify-center">
                    <Empty description={`No ${activeTab} teams`} image={Empty.PRESENTED_IMAGE_SIMPLE}>
                        {!auth.isTalentSupplierResource() && (
                            <Link to="/talent/team/setup" className="mx-auto btn btn-primary">
                                Create new team
                            </Link>
                        )}
                    </Empty>


                </div>
            ))}
        </div>
    );
}

export default TalentTeamsList;